export default "__VITE_PUBLIC_ASSET__bddb1926__"